<main class="admin-rules-wrapper">
  <header>
    <h1 class="mb-4">Zarządzanie regulaminem</h1>
  </header>
  <section>
    <div class="wide">
      <p-table
        #table
        (onPage)="onPrimePageChange($event)"
        (onSort)="onPrimeSortChange($event)"
        [customSort]="true"
        [lazy]="true"
        [loading]="isDataLoading()"
        [rows]="this.tablePage()?.size || 10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [totalRecords]="this.tablePage()?.totalElements || 0"
        [value]="rows()"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="flex"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="id" class="w-36 min-w-36 max-w-36">
              <div class="flex items-center gap-2">
                Identyfikator
                <p-sortIcon field="id" />
              </div>
            </th>
            <th pSortableColumn="dataUtworzenia">
              <div class="flex items-center gap-2">
                Data utworzenia
                <p-sortIcon field="dataUtworzenia" />
              </div>
            </th>
            <th pSortableColumn="dataOd">
              <div class="flex items-center gap-2">
                Data początku obowiązywania
                <p-sortIcon field="dataOd" />
              </div>
            </th>
            <th pSortableColumn="dataDo" style="width: 200px; min-width: 200px">
              <div class="flex items-center gap-2">
                Data końca obowiązywania
                <p-sortIcon field="dataDo" />
              </div>
            </th>
            <th
              alignFrozen="right"
              pFrozenColumn
              class="w-24 min-w-24 max-w-24"
            >
              Akcje
            </th>
          </tr>
          <tr>
            <td class="table-filter-cell w-36 min-w-36 max-w-36">
              <input
                (change)="onPrimeFilterChange($event.target, 'id')"
                aria-label="Filtruj po identyfikatorze"
                pInputText
                class="w-full min-w-0"
              />
            </td>
            <td
              style="width: 200px; min-width: 200px"
              class="table-filter-cell"
            >
              <p-date-picker
                (onClear)="onPrimeFilterChange($event, 'dataUtworzenia')"
                (onSelect)="onPrimeFilterChange($event, 'dataUtworzenia')"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
                class="w-full"
                dateFormat="dd-mm-yy"
                ariaLabel="Filtruj po dacie utworzenia"
              />
            </td>
            <td
              style="width: 200px; min-width: 200px"
              class="table-filter-cell"
            >
              <p-date-picker
                (onClear)="onPrimeFilterChange($event, 'dataOd')"
                (onSelect)="onPrimeFilterChange($event, 'dataOd')"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
                class="w-full"
                dateFormat="dd-mm-yy"
                ariaLabel="Filtruj po dacie początku obowiązywania"
              />
            </td>
            <td
              style="width: 200px; min-width: 200px"
              class="table-filter-cell"
            >
              <p-date-picker
                (onClear)="onPrimeFilterChange($event, 'dataDo')"
                (onSelect)="onPrimeFilterChange($event, 'dataDo')"
                [readonlyInput]="true"
                [showClear]="true"
                appendTo="body"
                class="w-full"
                dateFormat="dd-mm-yy"
                ariaLabel="Filtruj po dacie końca obowiązywania"
              />
            </td>
            <td
              alignFrozen="right"
              pFrozenColumn
              class="w-24 min-w-24 max-w-24"
            ></td>
          </tr>
        </ng-template>
        <ng-template #body let-rule>
          <tr>
            <td class="w-36 min-w-36 max-w-36">{{ rule.id }}</td>
            <td>{{ rule.dataUtworzenia | date: 'yyyy-MM-dd HH:mm' }}</td>
            <td>
              {{ rule.dataOd | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td>
              {{ rule.dataDo | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td
              alignFrozen="right"
              pFrozenColumn
              class="h-16 align-middle w-24 min-w-24 max-w-24"
            >
              <div class="flex items-center h-full gap-1 justify-end">
                <p-button
                  type="button"
                  (click)="openShowRuleDetailsModal(rule)"
                  ariaLabel="Zobacz szczegóły"
                  pTooltip="Zobacz szczegóły"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                >
                  <i class="pi pi-eye icon" aria-hidden="true"></i>
                </p-button>
                @if (!hideRemoveRuleAction(rule)) {
                  <p-button
                    type="button"
                    (click)="openRemoveRuleModal(rule)"
                    ariaLabel="Usuń"
                    pTooltip="Usuń"
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                  >
                    <app-icon [name]="'trash'"></app-icon>
                  </p-button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="5" class="text-center p-4 text-sm text-gray-500">
              Brak danych.
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div
        class="mt-4 flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
      >
        <p-button
          type="button"
          aria-label="Dodaj nową wersję"
          label="Dodaj nową wersję"
          styleClass="customInfoButton"
          [text]="true"
          (click)="onAddNewRuleVersionBtn()"
        />
        <div class="flex items-center gap-4">
          <p-paginator
            (onPageChange)="onPrimePageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50]"
            [rows]="tablePage()?.size || 10"
            [totalRecords]="tablePage()?.totalElements || 0"
            pageLinkSize="3"
            class="customPrimePaginator"
          />
          <div class="text-sm">
            <span>
              Strona {{ (tablePage()?.number || 0) + 1 }} z
              {{ tablePage()?.totalPages || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="narrow">
      <p-card class="mb-4">
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="contentFilterMobileLabel"
              >Identyfikator</span
            >
            <input
              (input)="onPrimeFilterChangeMobile($event.target, 'id')"
              pInputText
              class="w-full"
              aria-labelledby="contentFilterMobileLabel"
              [(ngModel)]="tableFilters.id"
            />
          </div>
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="confirmationFilterMobileLabel"
              >Data utworzenia</span
            >
            <p-date-picker
              (onClear)="onPrimeFilterChangeMobile($event, 'dataUtworzenia')"
              (onSelect)="onPrimeFilterChangeMobile($event, 'dataUtworzenia')"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              [(ngModel)]="tableFilters.dataUtworzenia"
              [showIcon]="true"
              [iconDisplay]="'input'"
              ariaLabel="Filtruj po dacie wpływu"
              inputId="dataWplywu"
            />
          </div>
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="requestCodeFilterMobileLabel"
              >Data początku obowiązywania</span
            >
            <p-date-picker
              (onClear)="onPrimeFilterChangeMobile($event, 'dataOd')"
              (onSelect)="onPrimeFilterChangeMobile($event, 'dataOd')"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              [(ngModel)]="tableFilters.dataOd"
              [showIcon]="true"
              [iconDisplay]="'input'"
              ariaLabel="Filtruj po dacie wpływu"
              inputId="dataWplywu"
            />
          </div>
          <div class="flex flex-col gap-3">
            <span class="font-bold" id="channelFilterMobileLabel"
              >Data końca obowiązywania</span
            >
            <p-date-picker
              (onClear)="onPrimeFilterChangeMobile($event, 'dataDo')"
              (onSelect)="onPrimeFilterChangeMobile($event, 'dataDo')"
              [readonlyInput]="true"
              [showClear]="true"
              appendTo="body"
              class="w-full customDatePicker"
              dateFormat="dd-mm-yy"
              [(ngModel)]="tableFilters.dataDo"
              [showIcon]="true"
              [iconDisplay]="'input'"
              ariaLabel="Filtruj po dacie wpływu"
              inputId="dataWplywu"
            />
          </div>
        </div>
        <div
          class="flex w-full gap-3 justify-start mt-3 md:w-auto md:gap-2 md:justify-end"
        >
          <p-button
            type="button"
            label="Wyczyść filtry"
            styleClass="customInfoButton outlined"
            (click)="clearFilters()"
          />
        </div>
      </p-card>

      <div class="flex flex-col gap-10">
        @for (rule of rows(); track rule.id) {
          <p-card>
            <div class="flex flex-col">
              <app-preview-data-wrapper
                label="Identyfikator"
                [data]="rule.id"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Data Utworzenia"
                [data]="rule.dataUtworzenia | date: 'yyyy-MM-dd HH:mm'"
                [dataType]="PreviewDataType.TEXT"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Data początku obowiązywania"
                [data]="rule.dataOd | date: 'yyyy-MM-dd HH:mm'"
                [dataType]="PreviewDataType.TEXT"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <app-preview-data-wrapper
                label="Data końca obowiązywania"
                [data]="rule.dataDo | date: 'yyyy-MM-dd HH:mm'"
                [dataType]="PreviewDataType.TEXT"
                additionalCssClasses="font-bold"
              ></app-preview-data-wrapper>
              <hr class="limiter" />
              <div class="flex justify-end gap-4 mt-5">
                <p-button
                  label="Zobacz szczegóły"
                  styleClass="customInfoButton outlined"
                  (click)="openShowRuleDetailsModal(rule)"
                />
                @if (!hideRemoveRuleAction(rule)) {
                  <p-button
                    label="Usuń"
                    styleClass="customInfoButton outlined"
                    (click)="openRemoveRuleModal(rule)"
                  />
                }
              </div>
            </div>
          </p-card>
        }

        @if (!rows().length && !isDataLoading()) {
          <p-card>
            <div>Brak danych</div>
          </p-card>
        }
      </div>
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements"
        pageLinkSize="3"
      />
      <div
        class="flex flex-col items-start gap-3 mt-5 md:flex-row md:items-center md:justify-between"
      >
        <div class="text-sm">
          <span>
            Strona {{ (tablePage()?.number || 0) + 1 }} z
            {{ tablePage()?.totalPages || 0 }}
          </span>
        </div>
        <p-button
          type="button"
          aria-label="Dodaj nową wersję"
          [text]="true"
          label="Dodaj nową wersję"
          styleClass="customInfoButton"
          (click)="onAddNewRuleVersionBtn()"
        />
      </div>
    </div>
  </section>
</main>



